export default "__VITE_ASSET__ByD0_F4E__"